"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { LinkSquare02Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";

type Props = {
  color?: string;
};

const LinkIcon: FC<Props> = ({ color = "currentColor" }) => (
  <HugeiconsIcon icon={LinkSquare02Icon} size={12} color={color} />
);

export default LinkIcon;
